// SPDX-License-Identifier: AGPL-3.0-or-later

import {ConfirmModal} from '@app/features/app/components/dialogs/ConfirmModal';
import * as MessageCommands from '@app/features/messaging/commands/MessageCommands';
import type {Message} from '@app/features/messaging/models/Message';
import * as ModalCommands from '@app/features/ui/commands/ModalCommands';
import {modal} from '@app/features/ui/commands/ModalCommands';
import {Trans, useLingui} from '@lingui/react/macro';
import {useCallback} from 'react';
export function useDeleteAttachment(message: Message | null | undefined, attachmentId: string | null | undefined) {
	const {t} = useLingui();
	return useCallback(
		(e: React.MouseEvent) => {
			e.preventDefault();
			e.stopPropagation();
			if (!message || !attachmentId) return;
			ModalCommands.push(
				modal(() => (
					<ConfirmModal
						title={t`Delete Attachment`}
						description={
							<Trans>
								Are you sure you want to delete this attachment? This action cannot be undone and will remove the
								attachment from this message.
							</Trans>
						}
						primaryText={t`Delete Attachment`}
						primaryVariant="danger-primary"
						onPrimary={async () => {
							await MessageCommands.deleteAttachment(message.channelId, message.id, attachmentId);
						}}
					/>
				)),
			);
		},
		[message, attachmentId, t],
	);
}
